import React from "react";
import { formatDateFull } from "../../utils/helper";
export const OfflineAlert = ({ item }) => {
  const arr = item.description.split("|");
  const machineId = arr[0];
  const machine = arr[1];
  const location = arr[2];
  const parent_location = arr[3];
  const machine_element = arr[4];
  const feature_name = arr[5];
  const feature_value = arr[6];

  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} container spacing={1}>
        <div className={"col-sm-12"}>
          <b>Machine Offline Detected</b>
        </div>
        <div className={"col-sm-4"}>Recorded on</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{formatDateFull(item.created_at)}</div>

        <div className={"col-sm-4"}>Machine</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{machine}</div>

        <div className={"col-sm-4"}>Element</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{machine_element}</div>

        <div className={"col-sm-4"}>Location</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>
          {parent_location} - {location}
        </div>
      </div>
    </div>
  );
};
